import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '../common/permission-service.service';

@Directive({
  selector: '[eoXorPermission]',
})
export class EoXorPermissionsDirective {
  @Input('eoXorPermission') permissions!: string[];

  constructor(
    private tokenService: PermissionService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    const hasPermission = this.tokenService.hasPermission(
      this.permissions,
      'XOR'
    );

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
